'use client';

import React, { useRef, useLayoutEffect, useState } from 'react';
import { DEFAULT_HIGHLIGHT_COLOR } from '../consts';
import styles from '../RichTextTable.module.css';
import type { Color } from 'libs/contentful/types';
import { cn, getColorway, getCustomBackgroundColor } from 'utils/styles';

function useHighlightColumnRect(highlightedColumnIndex: number) {
  const ref = useRef<HTMLDivElement>(null);
  const [rect, setRect] = useState<{ top: number; left: number; width: number; height: number } | null>(null);

  useLayoutEffect(() => {
    const measure = () => {
      const wrapper = ref.current;
      const table = wrapper?.querySelector('table');
      const cell = table?.querySelector<HTMLElement>('[data-highlighted="true"]');
      if (!wrapper || !table || !cell) return setRect(null);
      const wrapperRect = wrapper.getBoundingClientRect();
      const tableRect = table.getBoundingClientRect();
      const cellRect = cell.getBoundingClientRect();
      setRect({
        top: tableRect.top - wrapperRect.top,
        left: cellRect.left - wrapperRect.left,
        width: cellRect.width,
        height: tableRect.height,
      });
    };
    measure();
    if (!ref.current) return;
    const obs = new ResizeObserver(measure);
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [highlightedColumnIndex]);

  return [ref, rect] as const;
}

interface TableWrapperProps {
  children: React.ReactNode;
}

export const TableWrapper = ({ children }: TableWrapperProps) => {
  return <div className="relative">{children}</div>;
};
